import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { TaskStatuses } from "enums/taskStatuses";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { AdminFixtureList } from "./components/AdminFixtureList";
import { AdminSeasonList } from "./components/AdminSeasonList";

const DefaultPageSize = 10;
const DefaultTaskStatusOptionValue = Object.values(TaskStatuses)
  .filter((x) => x !== TaskStatuses.PUBLISHED)
  .map((x) => x.toLocaleUpperCase())
  .join(",");

export const AdminDashboardPage = () => {
  const { customerId } = useParams();
  const { formatMessage } = useIntl();

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle isLoading={false} title={formatMessage({ id: "adminDashboardPage.title" })} />
        <BackToButton to={`/${customerId}`} btnText={formatMessage({ id: "back.to.organizations" })} />
      </Row>
      <Divider />
      <AdminSeasonList pageSize={DefaultPageSize} defaultTaskStatusOptionValue={DefaultTaskStatusOptionValue} />
      <AdminFixtureList pageSize={DefaultPageSize} defaultTaskStatusOptionValue={DefaultTaskStatusOptionValue} />
    </>
  );
};
